// Frontend/geniac/src/api/paymentMethods.ts
// API client pour la gestion des moyens de paiement

import api from './client';

export interface PaymentMethod {
  id: string;
  card: {
    brand: string;
    last4: string;
    exp_month: number;
    exp_year: number;
    country: string;
  };
  is_default: boolean;
  created: number;
}

export interface SetupIntent {
  client_secret: string;
  setup_intent_id: string;
}

/**
 * Liste les moyens de paiement de l'organisation
 */
export async function listPaymentMethods(): Promise<PaymentMethod[]> {
  const response = await api.get('/api/payments/payment-methods');
  return response.data.payment_methods;
}

/**
 * Créer un Setup Intent pour ajouter une nouvelle carte
 */
export async function createSetupIntent(): Promise<SetupIntent> {
  const response = await api.post('/api/payments/setup-intent');
  return {
    client_secret: response.data.client_secret,
    setup_intent_id: response.data.setup_intent_id
  };
}

/**
 * Ajouter un moyen de paiement après confirmation du Setup Intent
 */
export async function addPaymentMethod(paymentMethodId: string): Promise<void> {
  await api.post('/api/payments/payment-methods', {
    payment_method_id: paymentMethodId
  });
}

/**
 * Définir un moyen de paiement comme défaut
 */
export async function setDefaultPaymentMethod(paymentMethodId: string): Promise<void> {
  await api.patch(`/api/payments/payment-methods/${paymentMethodId}/set-default`);
}

/**
 * Supprimer un moyen de paiement
 */
export async function removePaymentMethod(paymentMethodId: string): Promise<void> {
  await api.delete(`/api/payments/payment-methods/${paymentMethodId}`);
}
